import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TerminalFormModal } from './components/TerminalFormModal';
import { TerminalsTable } from './components/TerminalsTable';
import { useTerminalsPageController } from './useTerminalsPageController';
import classes from './terminals-page.module.scss';

// Summary: Super-admin payment-terminals (Dejavoo/Z-Credit) management screen (Hebrew, RTL).
// Details: docs/function-library/web/contexts-pages.md#terminals-page
export const TerminalsPage: React.FC = () => {
  const {
    terminals,
    isLoadingTerminals,
    companies,
    companyNameByTenantId,
    form,
    isSubmitting,
    isModalOpen,
    expandedTerminalId,
    displayedError,
    terminalsCountLabel,
    isEditing,
    modalTitle,
    submitLabel,
    openCreateModal,
    openEditModal,
    closeModal,
    handleSubmitTerminal,
    onChangeForm,
    onChangePinpad,
    onAddPinpad,
    onRemovePinpad,
    onToggleExpanded,
  } = useTerminalsPageController();

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.toolbar}>
          <div className={classes.titleBlock}>
            <h2 className={classes.title}>ניהול מסופי אשראי</h2>
            <p className={classes.subtitle}>{terminalsCountLabel}</p>
          </div>
          <button type="button" className={classes.createButton} onClick={openCreateModal} data-testid="terminals-create">
            <span>צור מסוף</span>
            <FontAwesomeIcon icon={faPlus as IconProp} className={classes.plusIcon} aria-hidden="true" />
          </button>
        </div>

        {displayedError && <p className={classes.error}>{displayedError}</p>}
        <TerminalsTable
          terminals={terminals}
          isLoadingTerminals={isLoadingTerminals}
          companyNameByTenantId={companyNameByTenantId}
          expandedTerminalId={expandedTerminalId}
          onToggleExpanded={onToggleExpanded}
          onEditTerminal={openEditModal}
        />
      </div>

      <TerminalFormModal
        isOpen={isModalOpen}
        isEditing={isEditing}
        modalTitle={modalTitle}
        submitLabel={submitLabel}
        form={form}
        companies={companies}
        companyNameByTenantId={companyNameByTenantId}
        isSubmitting={isSubmitting}
        onClose={closeModal}
        onSubmit={handleSubmitTerminal}
        onChangeForm={onChangeForm}
        onChangePinpad={onChangePinpad}
        onAddPinpad={onAddPinpad}
        onRemovePinpad={onRemovePinpad}
      />
    </div>
  );
};
